var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.scope.row[_vm.config.prop]),function(item,index){return _c('el-tag',{key:index,attrs:{"size":"mini"}},[_vm._v(" "+_vm._s(_vm.getLabelFormList(item))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }